import { render, staticRenderFns } from "./MetaCevizLogin.vue?vue&type=template&id=72128012"
import script from "./MetaCevizLogin.vue?vue&type=script&lang=js"
export * from "./MetaCevizLogin.vue?vue&type=script&lang=js"
import style0 from "./MetaCevizLogin.vue?vue&type=style&index=0&id=72128012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports